import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_CONFIG } from '../config/auth-config';
import { IAuthService } from '../services/iauth.service';

/**
 * Guard que protege rotas que necessitam autenticação
 * Redireciona para login se o token estiver inválido
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(IAuthService);
  const router = inject(Router);
  const config = inject(AUTH_CONFIG);

  if (authService.isAccessTokenInvalido()) {
    return authService.obterNovoAccessToken().then(() => {
      if (authService.isAccessTokenInvalido()) {
        const loginRoute = config.routes?.loginRoute || 'login';
        router.navigate(['/', loginRoute]);
        return false;
      }
      return true;
    });
  }

  // Verifica permissões se especificadas na rota
  if (route.data['roles']) {
    const hasPermission = authService.havePermission(...route.data['roles']);
    if (!hasPermission) {
      router.navigate(['/acesso-negado']);
      return false;
    }
  }

  return true;
};
